import {management} from '../../../index';

export class GetSensorReportHistoryGraphic {
  // Get data needed to build the history of management sector graphic
  async execute(SENSOR_NAME, {start, end}){
    // const raw = `
    //   SELECT TEMPO TIME, 
    //   FORMAT(AVG(IF(SENSOR > MEDIA - 2 * (DESV+MEDIA/1000) OR SENSOR < MEDIA + 2 * (DESV+MEDIA/1000), SENSOR,NULL)), 2) AS VALUE,
    // '${SENSOR_NAME}' SENSOR_NAME
    //   FROM
    //       (SELECT * FROM 
    //           (SELECT DATE(\`TIME\`) AS TEMPO, VALUE AS SENSOR FROM LOG_SENSOR.\`${SENSOR_NAME}\`
    //           WHERE (DATE(\`TIME\`) BETWEEN '${start}' AND '${end}')
    //           AND \`UNIT\` = '%') AS ORIGINAL
    //       LEFT JOIN
    //           (SELECT DATE(\`TIME\`) AS TM, AVG(VALUE) AS MEDIA, STDDEV_SAMP(VALUE) AS DESV FROM LOG_SENSOR.\`${SENSOR_NAME}\`
    //           WHERE (DATE(\`TIME\`) BETWEEN '${start}' AND '${end}')
    //           AND \`UNIT\` = '%'
    //           GROUP BY TM) AS MEDIA
    //       ON ORIGINAL.TEMPO = MEDIA.TM) AS FILTRADO
    //   GROUP BY TEMPO
    //   HAVING AVG(IF(SENSOR > MEDIA - 2 * (DESV+MEDIA/1000) OR SENSOR < MEDIA + 2 * (DESV+MEDIA/1000), SENSOR,NULL)) IS NOT NULL
    // `;

    const raw = `
      SELECT TEMPO TIME, 
      FORMAT(AVG(IF(((SENSOR - MEDIA) BETWEEN -1.8*(DESV + MEDIA/100) AND 1.8*(DESV + MEDIA/100)), SENSOR, NULL)), 2) AS VALUE,
      '${SENSOR_NAME}' SENSOR_NAME
      FROM
      (SELECT TEMPO, SENSOR, MEDIA, DESV FROM 
          (SELECT DATE(\`TIME\`) AS TEMPO, 
          IF(DAY(\`TIME\`) % 2 = 1, DATE(\`TIME\`) + INTERVAL(IF(DAY(\`TIME\`) = 31, -1, 1)) DAY, DATE(\`TIME\`)) AS AVG_TIME,
          VALUE AS SENSOR FROM LOG_SENSOR.\`${SENSOR_NAME}\`
          WHERE (DATE(\`TIME\`) BETWEEN '${start}' AND '${end}')
          AND \`UNIT\` = '%') AS ORIGINAL
      LEFT JOIN
          (SELECT 
          IF(DAY(\`TIME\`) % 2 = 1, DATE(\`TIME\`) + INTERVAL(IF(DAY(\`TIME\`) = 31, -1, 1)) DAY, DATE(\`TIME\`)) AS AVG_TIME, 
          AVG(VALUE) AS MEDIA, 
          IFNULL(STDDEV_SAMP(VALUE),0) AS DESV 
          FROM LOG_SENSOR.\`${SENSOR_NAME}\`
          WHERE (DATE(\`TIME\`) BETWEEN '${start}' AND '${end}')
          AND \`UNIT\` = '%'
          GROUP BY 1) AS MEDIA
      ON ORIGINAL.AVG_TIME = MEDIA.AVG_TIME) AS FILTRADO
      GROUP BY TEMPO
      HAVING VALUE IS NOT NULL
    `;

    return await management
      .sql({
        data: {
          sql: raw
        }
      })
      .then(r => r && r[0])
      .then(r => {
        if(r && r.length) {
          return r.map(r => {
            r.VALUE = Number(r.VALUE);

            return r;
          })

        } else {
          return [];

        }
      })
  }
}
